import React from "react"
import { Grid, Paper, Typography } from "@mui/material"
import DMVBarChart from "components/DMVBarChart"
import DMVLineCharts from "components/DMVLineCharts"

const AnalyticsCharts = ({ analyticsData = {} }) => {
  // Transform status_breakdown data for bar chart
  const statusBreakdownData = Object.entries(analyticsData.status_breakdown || {}).map(
    ([status, count]) => ({ status, count })
  )
  // Transform redemption over time data for line chart
  const redemptionTimelineData =
    analyticsData.redemption_timeline?.map((item) => {
      const [year, month, day] = item.date.split("-")
      const formatted = new Date(year, month - 1, day).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric"
      })
      return { date: formatted, count: item.count }
    }) || []

  return (
    <Grid container spacing={3} sx={{ mt: 1 }}>
      {/* Status Breakdown Chart */}
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 3, overflow: "hidden" }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
            Redemption Status Breakdown
          </Typography>
          {statusBreakdownData.length > 0 ? (
            <DMVBarChart data={statusBreakdownData} height={300} xKey="status" dataKey="count" />
          ) : (
            <Typography color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
              No status breakdown data available
            </Typography>
          )}
        </Paper>
      </Grid>

      {/* Redemption Timeline Chart */}
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 3, overflow: "hidden" }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
            Redemptions Over Time
          </Typography>
          {redemptionTimelineData.length > 0 ? (
            <DMVLineCharts data={redemptionTimelineData} height={300} dataKey="count" xKey="date" />
          ) : (
            <Typography color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
              No redemption data available
            </Typography>
          )}
        </Paper>
      </Grid>
    </Grid>
  )
}

export default AnalyticsCharts
